module.exports = __webpack_public_path__ + "img/sp3.db85fd42.svg";